import React, { useState } from 'react';
import SafeIcon from '../../common/SafeIcon';

export default function FeatureFolder({ feature }) {
  const [isHovered, setIsHovered] = useState(false);
  const gradient = feature.gradient;

  return (
    <div 
      className="relative flex flex-col items-center justify-center p-4 rounded-2xl cursor-pointer group w-full max-w-[200px]"
      style={{ minHeight: "200px", perspective: "1200px" }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Background glow when hovered */}
      <div 
        className="absolute inset-0 rounded-2xl transition-opacity duration-700 pointer-events-none"
        style={{ 
          background: `radial-gradient(circle at 50% 70%, ${gradient.split(',')[1].trim()} 0%, transparent 70%)`,
          opacity: isHovered ? 0.15 : 0 
        }}
      />
      
      <div className="relative flex items-center justify-center mt-6" style={{ height: "112px", width: "144px" }}>
        
        {/* Folder Tab */}
        <div 
          className="absolute left-4 -top-4 w-16 h-5 rounded-t-lg border-t border-x border-white/20 shadow-sm"
          style={{ 
            background: gradient, 
            filter: "brightness(0.85)",
            transformOrigin: "bottom center",
            transform: isHovered ? "rotateX(-20deg) skewX(-5deg)" : "rotateX(0deg)",
            transition: "transform 500ms cubic-bezier(0.16, 1, 0.3, 1)",
            zIndex: 10
          }}
        />
        
        {/* Folder Back */}
        <div 
          className="absolute inset-0 rounded-lg shadow-md border border-white/20"
          style={{ 
            background: gradient,
            filter: "brightness(0.9)",
            transformOrigin: "bottom center",
            transform: isHovered ? "rotateX(-15deg) scaleY(1.02)" : "rotateX(0deg) scaleY(1)",
            transition: "transform 500ms cubic-bezier(0.16, 1, 0.3, 1)",
            zIndex: 10
          }}
        />
        
        {/* Pop-out Card (Fixed centering for mobile) */}
        <div 
          className="absolute left-0 right-0 mx-auto w-[130px] bg-white rounded-xl shadow-2xl flex flex-col items-center justify-center px-3 py-4 text-center border border-slate-100"
          style={{ 
            bottom: "20px", 
            transformOrigin: "bottom center",
            transform: isHovered ? "translateY(-85px) scale(1.05)" : "translateY(0) scale(0.6)",
            opacity: isHovered ? 1 : 0,
            transition: "all 500ms cubic-bezier(0.16, 1, 0.3, 1)",
            zIndex: 40,
            pointerEvents: "none"
          }}
        >
          <div className="mb-3">
            <SafeIcon name={feature.icon.replace('Fi', '')} className="w-8 h-8 text-slate-700" />
          </div>
          <h4 className="text-[11px] font-bold text-slate-900 mb-1.5 leading-tight">{feature.title}</h4>
          <p className="text-[9px] text-slate-500 leading-snug">{feature.desc}</p>
        </div>

        {/* Folder Front */}
        <div 
          className="absolute inset-0 rounded-lg shadow-xl border border-white/30 flex items-center justify-center p-3 text-center"
          style={{ 
            background: gradient,
            transformOrigin: "bottom center",
            transform: isHovered ? "rotateX(45deg) translateY(12px)" : "rotateX(0deg) translateY(0)",
            transition: "transform 500ms cubic-bezier(0.16, 1, 0.3, 1)",
            zIndex: 30
          }}
        >
          <span 
            className="text-white font-bold text-xs drop-shadow-md"
            style={{ 
              opacity: isHovered ? 0 : 1,
              transition: "opacity 300ms",
            }}
          >
            {feature.title}
          </span>
        </div>
      </div>
    </div>
  );
}